"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1555],{

/***/ 31555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50743);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27959);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61201);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64566);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  min-height: auto;\n  &.Mui-expanded {\n    min-height: auto;\n    color: #4e7a0a;\n  }\n\n  .MuiAccordionSummary-content {\n    margin: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: ",
        "px;\n  margin-bottom: ",
        "px;\n\n  background-color: #f0f0f0;\n  box-shadow: none;\n\n  &.Mui-expanded {\n    background-color: #f8f8f8;\n  }\n\n  :before {\n    display: none;\n  }\n\n  &.MuiExpansionPanel-root {\n    border: none;\n    border-radius: 8px 8px 0 0;\n  }\n\n  &.MuiExpansionPanel-root:before {\n    display: none;\n    height: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  color: ",
        ";\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  & > p {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function Accordion(param) {
    var summary = param.summary, details = param.details;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledAccordion, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAccordionSummary, {
                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                children: typeof summary === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                    py: 1,
                    variant: "subtitle1",
                    fontWeight: 600,
                    fontSize: 16,
                    component: "h3",
                    children: summary
                }) : summary
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAccordionDetails, {
                children: typeof details === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                    fontSize: 16,
                    pb: 2,
                    variant: "subtitle2",
                    children: details
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: details
                })
            })
        ]
    });
}
var StyledAccordionSummary = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 1.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 3);
});
var StyledAccordion = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_templateObject1(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1.5);
});
var StyledAccordionDetails = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_templateObject2(), function(props) {
    return props.theme.palette.grey[700];
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1, 3, 0, 1.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 8, 0, 3);
});
/* harmony default export */ __webpack_exports__["default"] = (Accordion);


/***/ })

}]);